import { WEEKDAY_CODES, addDays, clockParts, clockText, daysBetween, isoDate, normalizeLeads, repeatFields, shiftDays, wallParts, weekdayCode } from '../../lib/calendar.js'
import { userZone } from '../../lib/time.js'

const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- calendar-event-form ---
let __fez_component_0;
{
const REPEATS = [
  { value: 'none', label: 'Does not repeat' },
  { value: 'daily', label: 'Every day' },
  { value: 'weekly', label: 'Every week' },
  { value: 'monthly', label: 'Every month' },
  { value: 'yearly', label: 'Every year' },
]
const ENDS = [
  { value: 'never', label: 'Never' },
  { value: 'until', label: 'On a date' },
  { value: 'count', label: 'After a number of times' },
]
const DAY_LABELS = { MO: 'Mon', TU: 'Tue', WE: 'Wed', TH: 'Thu', FR: 'Fri', SA: 'Sat', SU: 'Sun' }

/** A mailbox's address: its name at its first domain. */
function address(mailbox) {
  const prefix = mailbox.aliases?.[0] || ''
  return mailbox.domains?.length ? `${prefix}@${mailbox.domains[0]}` : prefix
}

/** Wall milliseconds of a form date and time (UTC fields), NaN when either is not there. */
function stamp(date, time) {
  return date ? new Date(`${date}T${time || '00:00'}Z`).getTime() : NaN
}

/** The `event_save` params of the form's times and repeat (`f`), on the clock of the zone sent with them. */
function timing(f, series) {
  const params = {
    all_day: f.allDay,
    start: f.allDay ? f.start.date : `${f.start.date}T${f.start.time || '00:00'}`,
    end: f.allDay ? addDays(f.end.date, 1) : `${f.end.date}T${f.end.time || '00:00'}`,
  }
  if (!series) return params
  params.repeat = f.repeat
  if (f.repeat !== 'none') {
    params.repeat_days = f.repeat === 'weekly' ? f.days : []
    if (f.ends === 'until') params.repeat_until = f.until || undefined
    if (f.ends === 'count') params.repeat_count = Number(f.count) || undefined
  }
  return params
}
__fez_component_0 = class {
  PROPS = {
    mailbox: String,
    event: { type: Object, default: null },
    instance: Number,
    occurrence: { type: Object, default: null },
    start: { type: Object, default: null },
    end: { type: Object, default: null },
    all_day: Boolean,
    email: String,
    title: String,
  }

  init() {
    const event = this.props.event
    const instance = event && this.props.instance !== undefined && this.props.instance !== null
    this.state.mode = event ? (instance ? 'instance' : 'series') : 'new'
    const session = this.globalState.mailboxSession
    // Send from: the mailboxes I may send from; a mailbox session sends from its own.
    this.senders = session ? [session] : (this.globalState.mailboxes || []).filter((mailbox) => mailbox.can_send)
    this.state.fixed = session?.ref || (event?.owner?.startsWith('mbx_') ? event.owner : '')
    const preferred = this.senders.find((mailbox) => mailbox.ref === this.props.mailbox) || this.senders[0]
    this.state.mailbox = this.state.fixed || preferred?.ref || ''
    let start = this.props.start || { date: '', time: '' }
    let end = this.props.end || start
    let allDay = this.props.all_day
    let text = event || {}
    let rrule = ''
    let own = null
    if (event) {
      const changed = instance ? (event.overrides || []).find((entry) => entry.instance === this.props.instance) : null
      const when = changed || (instance ? this.props.occurrence : null) || event
      text = changed ? { ...event, ...changed, description: changed.description } : event
      allDay = Boolean(when.all_day)
      rrule = this.state.mode === 'series' ? event.rrule : ''
      start = clockParts(when.start)
      end = clockParts(when.end)
      // The API's all-day end is the day after; the form shows the last day.
      if (allDay) end = { date: addDays(end.date, -1), time: '' }
      const tzid = event.tzid || 'UTC'
      if (!allDay && tzid !== userZone()) own = { tzid, start: wallParts(when.start), end: wallParts(when.end), repeat: repeatFields(rrule, tzid) }
    }
    const repeat = repeatFields(rrule, userZone())
    // Weekdays of a rule made on another clock move with the start's day on mine.
    if (own) repeat.days = shiftDays(repeat.days, daysBetween(own.start.date, start.date))
    this.state.values = {
      title: text.summary || this.props.title || '',
      location: text.location || '',
      url: text.url || '',
      description: text.description || '',
      start,
      end,
      repeat: repeat.repeat,
      until: repeat.until,
      count: repeat.count || '10',
      attendees: (event?.attendees || []).map((person) => person.address).join(', '),
    }
    this.state.allDay = allDay
    this.state.countdown = Boolean(event?.countdown)
    // The countdown shown is the opened calendar's: it is sent only when changed, for that calendar.
    this.countedAtStart = this.state.countdown
    this.state.repeat = repeat.repeat
    this.state.ends = repeat.ends
    this.state.days = repeat.days.length ? repeat.days : start.date ? [weekdayCode(start.date)] : []
    // An event made in another zone keeps it while its times and repeat stay as shown.
    const series = this.state.mode !== 'instance'
    const shown = { allDay, start, end, repeat: repeat.repeat, ends: repeat.ends, days: this.state.days, until: repeat.until, count: this.state.values.count }
    this.kept = own ? {
      shown: JSON.stringify(timing(shown, series)),
      params: { ...timing({ ...shown, start: own.start, end: own.end, days: own.repeat.days.length ? own.repeat.days : [weekdayCode(own.start.date)], until: own.repeat.until }, series), tzid: own.tzid },
    } : null
    this.state.startAt = stamp(start.date, start.time)
    this.state.inviting = Boolean(this.state.values.attendees)
    this.state.invited = this.state.inviting
    this.state.errors = {}
    this.state.strip = { day: start.date, slot: allDay ? null : { start, end } }
    this.state.saving = false
    this.state.reminders = normalizeLeads(event ? event.reminders : this.globalState.me?.reminders)
    this.state.repeats = REPEATS
    this.state.endsOptions = ENDS
    this.state.senderOptions = this.senders.map((mailbox) => ({ value: mailbox.ref, label: `${mailbox.display_name || mailbox.aliases?.[0] || ''} <${address(mailbox)}>` }))
  }

  changed(event) {
    const target = event.target
    if (target.name === 'all_day') this.state.allDay = target.checked
    else if (target.name === 'countdown') this.state.countdown = target.checked
    else if (target.name === 'repeat') this.state.repeat = target.value
    else if (target.name === 'ends') this.state.ends = target.value
    else if (target.name === 'mailbox') this.state.mailbox = target.value
    else if (target.name === 'start_date' || target.name === 'start_time') this.moveEnd(target.form)
    else if (target.name === 'repeat_days') this.state.days = [...target.form.querySelectorAll('input[name="repeat_days"]:checked')].map((input) => input.value)
    if (this.props.email && /^(all_day|start_|end_)/.test(target.name)) this.follow(target.form)
  }

  // The day strip follows the start's day and the times.
  follow(form) {
    const fields = form.elements
    const start = { date: fields.start_date.value, time: fields.start_time?.value || '' }
    const end = { date: fields.end_date.value || start.date, time: fields.end_time?.value || '' }
    this.state.strip = { day: start.date, slot: this.state.allDay || !start.time ? null : { start, end } }
  }

  typed(event) {
    if (event.target.name === 'attendees') this.state.inviting = event.target.value.trim() !== ''
  }

  setReminders(list) {
    this.state.reminders = list
  }

  // The end keeps its distance from the start.
  moveEnd(form) {
    const fields = form.elements
    const next = stamp(fields.start_date.value, fields.start_time?.value)
    const end = stamp(fields.end_date.value, fields.end_time?.value)
    const before = this.state.startAt
    this.state.startAt = next
    if ([next, end, before].some(Number.isNaN)) return
    const moved = new Date(end + (next - before))
    fields.end_date.value = isoDate(moved)
    if (fields.end_time) fields.end_time.value = clockText(moved.getUTCHours() * 60 + moved.getUTCMinutes())
  }

  async save(event) {
    event.preventDefault()
    const form = event.target
    const values = this.formData(form)
    const allDay = this.state.allDay
    const series = this.state.mode !== 'instance'
    const errors = {}
    if (!(values.title || '').trim()) errors.title = 'is required'
    if (!values.start_date) errors.start = 'is required'
    if (!values.end_date) errors.end = 'is required'
    if (Object.keys(errors).length) {
      this.state.errors = errors
      return
    }
    const fields = {
      allDay,
      start: { date: values.start_date, time: values.start_time || '' },
      end: { date: values.end_date, time: values.end_time || '' },
      repeat: this.state.repeat,
      ends: this.state.ends,
      days: this.state.days,
      until: values.repeat_until,
      count: values.repeat_count,
    }
    const shown = timing(fields, series)
    const when = this.kept && JSON.stringify(shown) === this.kept.shown ? this.kept.params : { ...shown, tzid: allDay ? undefined : userZone() }
    const params = {
      mailbox: undefined,
      event: this.props.event?.ref,
      instance: this.state.mode === 'instance' ? this.props.instance : undefined,
      title: values.title.trim(),
      ...when,
      location: values.location || '',
      url: values.url || '',
      description: values.description || '',
      email: this.state.mode === 'new' ? this.props.email || undefined : undefined,
    }
    if (this.globalState.me) params.reminders = this.state.reminders
    if (series) {
      params.attendees = (values.attendees || '').split(/[,;]/).map((entry) => entry.trim()).filter(Boolean)
      if (this.state.countdown !== this.countedAtStart) {
        params.countdown = this.state.countdown
        if (this.props.event) params.calendar = this.props.event.calendar || undefined
      }
    }
    // Nobody invited and no organizer mailbox: a personal event.
    if (this.state.fixed || (series ? params.attendees.length : this.state.invited)) params.mailbox = this.state.mailbox || undefined
    this.state.saving = true
    try {
      await window.App.api('calendar/event_save', params)
      window.Dialog.close(true)
    } catch (error) {
      this.state.errors = error.details || {}
    } finally {
      this.state.saving = false
    }
  }

  beforeRender() {
    const series = this.state.mode !== 'instance'
    this.state.series = series
    this.state.weekly = series && this.state.repeat === 'weekly'
    this.state.repeating = series && this.state.repeat !== 'none'
    this.state.weekdays = WEEKDAY_CODES.map((code) => ({ code, label: DAY_LABELS[code], on: this.state.days.includes(code) }))
    const sender = this.senders.find((mailbox) => mailbox.ref === this.state.mailbox)
    this.state.emailHint = this.props.email ? 'It links back to the email.' : ''
    const organizer = (this.state.fixed && this.props.event?.organizer) || (sender ? address(sender) : '')
    this.state.inviteHint = organizer.includes('@') ? `They get an invitation from ${organizer}, and an update when it changes.` : 'They get an invitation from the Send from mailbox, and an update when it changes.'
    this.state.fixedText = this.state.fixed ? (sender ? `${sender.display_name || sender.aliases?.[0] || ''} <${address(sender)}>` : this.props.event?.organizer || '') : ''
    // Send from shows once someone is invited; a mailbox session sends from its own.
    this.state.pickSender = series && this.state.inviting && !this.state.fixed && !this.globalState.mailboxSession
    this.state.showFixed = Boolean(this.state.fixedText) && !this.globalState.mailboxSession
    this.state.personalHint = series && !this.state.inviting && !this.state.fixed && this.globalState.me ? 'Nobody invited: it is yours alone, in My calendar.' : ''
    this.state.sending = series ? this.state.inviting || this.state.invited : this.state.invited
    this.state.confirm = this.state.sending ? 'Save and send' : 'Save'
    this.state.resetHint = this.state.mode === 'series' && this.props.event?.overrides?.length ? 'Changing the start or how it repeats undoes the changes made to single events of this series.' : ''
    this.state.instanceHint = this.state.mode === 'instance' ? `Only this event changes; the rest of the series stays as it is.${this.state.invited ? ' The attendees get the update.' : ''}` : ''
  }

  CSS = `:fez {
display:block;form{display:grid;gap:var(--space-4)}.ef-note{margin:0;color:var(--color-text-muted);font-size:var(--text-sm)}.ef-pair{display:grid;grid-template-columns:minmax(0,3fr) minmax(0,2fr);gap:var(--space-3);align-items:end;&.off{grid-template-columns:minmax(0,1fr)} :mobile {grid-template-columns:minmax(0,1fr)}}.ef-hide{display:none}.ef-check{display:inline-flex;align-items:center;gap:var(--space-2);justify-self:start;font-size:var(--text-sm);font-weight:var(--weight-medium);cursor:pointer}.ef-label{font-size:var(--text-sm);font-weight:var(--weight-semibold)}.ef-days{display:grid;gap:6px}.ef-day-row{display:flex;flex-wrap:wrap;gap:var(--space-1)}.ef-day{position:relative;display:inline-grid;place-items:center;min-width:44px;height:32px;padding:0 var(--space-2);border:1px solid var(--color-border-strong);border-radius:var(--radius-full);color:var(--color-text-muted);font-size:var(--text-sm);font-weight:var(--weight-medium);cursor:pointer;input{position:absolute;opacity:0;pointer-events:none}&.on{border-color:var(--color-accent);background:var(--color-accent);color:var(--color-accent-text)}&:has(input:focus-visible){outline:2px solid var(--color-focus);outline-offset:2px}}.ef-from{display:grid;gap:var(--space-1);font-size:var(--text-sm)}.ef-error{margin:0;color:var(--color-danger);font-size:var(--text-sm)}
}`

  HTML = `<form onsubmit="fez.save(event)" onchange="fez.changed(event)" oninput="fez.typed(event)" novalidate>
{#if state.instanceHint}<p class="ef-note">{state.instanceHint}</p>{/if}
{#if state.emailHint}<p class="ef-note">{state.emailHint}</p>{/if}
<ui-input name="title" label="Title" value={state.values.title} placeholder="Team lunch" maxlength="500" error={state.errors.title} autofocus required></ui-input>
<label class="ef-check"><input type="checkbox" name="all_day" checked={state.allDay}> All day</label>
{#if state.series}
<label class="ef-check" title="The 30 days before it say how far off it is, for everyone who reads the calendar"><input type="checkbox" name="countdown" checked={state.countdown}> Count down to it</label>
{/if}
<div class="ef-pair" class:off={state.allDay}>
<ui-input name="start_date" type="date" label="Starts" value={state.values.start.date} error={state.errors.start}></ui-input>
<div class:ef-hide={state.allDay}><ui-input name="start_time" type="time" step="300" label="Time" value={state.values.start.time}></ui-input></div>
</div>
<div class="ef-pair" class:off={state.allDay}>
<ui-input name="end_date" type="date" label="Ends" value={state.values.end.date} error={state.errors.end}></ui-input>
<div class:ef-hide={state.allDay}><ui-input name="end_time" type="time" step="300" label="Time" value={state.values.end.time}></ui-input></div>
</div>
{#if globalState.me}
<calendar-reminders label="Notify me" :value="state.reminders" error={state.errors.reminders} :on_change="(list) => fez.setReminders(list)"></calendar-reminders>
{/if}
{#if props.email}
<calendar-day-strip day={state.strip.day} :slot="state.strip.slot"></calendar-day-strip>
{/if}
{#if state.series}
<ui-select name="repeat" label="Repeat" :options="state.repeats" value={state.values.repeat} error={state.errors.repeat}></ui-select>
{#if state.weekly}
<div class="ef-days" role="group" aria-label="On these days">
<span class="ef-label">On</span>
<div class="ef-day-row">
{#each state.weekdays as day}
<label class="ef-day" class:on={day.on} key={day.code}><input type="checkbox" name="repeat_days" value={day.code} checked={day.on}>{day.label}</label>
{/each}
</div>
{#if state.errors.repeat_days}<span class="ef-error">{state.errors.repeat_days}</span>{/if}
</div>
{/if}
{#if state.repeating}
<div class="ef-pair" class:off={state.ends === 'never'}>
<ui-select name="ends" label="Ends" :options="state.endsOptions" value={state.ends}></ui-select>
{#if state.ends === 'until'}
<ui-input name="repeat_until" type="date" label="Last day" value={state.values.until} error={state.errors.repeat_until}></ui-input>
{:else if state.ends === 'count'}
<ui-input name="repeat_count" type="number" label="Times" value={state.values.count} error={state.errors.repeat_count}></ui-input>
{/if}
</div>
{/if}
{#if state.resetHint}<p class="ef-note">{state.resetHint}</p>{/if}
{/if}
<ui-input name="location" label="Location" value={state.values.location} placeholder="Room 4, or an address" error={state.errors.location}></ui-input>
<ui-input name="url" type="url" label="Meeting link" value={state.values.url} placeholder="https://meet.example.com/..." error={state.errors.url}></ui-input>
{#if state.series}
<ui-input name="attendees" label="Invite" value={state.values.attendees} placeholder="ana@example.com, ivo@example.com" hint={state.inviteHint} error={state.errors.attendees}></ui-input>
<recipient-suggest></recipient-suggest>
{#if state.pickSender}
{#if state.senderOptions.length}
<ui-select name="mailbox" label="Send from" :options="state.senderOptions" value={state.mailbox} error={state.errors.mailbox}></ui-select>
{:else}
<p class="ef-error">You may not send from any mailbox, so you cannot invite anyone.</p>
{/if}
{:else if state.personalHint}
<p class="ef-note">{state.personalHint}</p>
{/if}
{/if}
{#if state.showFixed}
<div class="ef-from"><span class="ef-label">Send from</span><span>{state.fixedText}</span></div>
{/if}
<ui-textarea name="description" label="Description" value={state.values.description} rows="3" autogrow error={state.errors.description}></ui-textarea>
<div class="dialog-actions">
<ui-button label="Cancel" onclick="Dialog.cancel()"></ui-button>
<ui-button type="submit" variant="primary" label={state.confirm} :loading="state.saving"></ui-button>
</div>
</form>`
};
}

Fez('calendar-event-form', __fez_component_0);

export default __fez_component_0;
